import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  DailyResponse,
  InstitutionContext,
  InstitutionalServiceContext,
  Last24hResponse,
  MonthlyResponse,
} from 'src/app/components/client/institution-history/traffic-history.models';
import { BaseApiEndpoint } from './base-endpoint';

export class TrafficHistoryEndpoint extends BaseApiEndpoint {
  getInstitutionalServices(): Observable<InstitutionalServiceContext[]> {
    return this._http
      .get<any>(`${this.path}institutional-services`)
      .pipe(map((res) => res.data));
  }

  getInstitutionContext(clientServiceId: number): Observable<InstitutionContext> {
    return this._http
      .get<any>(`${this.path}${clientServiceId}/institution-context`)
      .pipe(map((res) => res.data));
  }

  getLast24h(clientServiceId: number): Observable<Last24hResponse> {
    return this._http
      .get<any>(`${this.path}${clientServiceId}/traffic/last-24h`)
      .pipe(map((res) => res.data));
  }

  getDaily(clientServiceId: number, from: string, to: string): Observable<DailyResponse> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this._http
      .get<any>(`${this.path}${clientServiceId}/traffic/daily`, { params })
      .pipe(map((res) => res.data));
  }

  getMonthly(clientServiceId: number, from: string, to: string): Observable<MonthlyResponse> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this._http
      .get<any>(`${this.path}${clientServiceId}/traffic/monthly`, { params })
      .pipe(map((res) => res.data));
  }
}
